<template>
  <v-combobox
    v-if="allowCustomValues"
    :items="lookupOptions()"
    :loading="loading"
    item-text="value"
    item-value="valueid"
    :value="value"
    :error-messages="errors"
    v-bind="$attrs"
    @change="maybeSaveCustomValue"
    :label="theLabel"
  />
  <v-autocomplete
    v-else
    :items="lookupOptions()"
    :loading="loading"
    item-text="value"
    item-value="valueid"
    :value="value"
    :error-messages="errors"
    v-bind="$attrs"
    :label="theLabel"
    :disabled="errors.length ? true : false"
    @input="$emit('input', $event || null)"
    :filter="filterItems"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // lookupOptions: [],
      loading: false,
      errors: []
    };
  },
  methods: {
    handleError(e) {
      this.errors.push(e.message);
    },
    lookupOptions() {
      return this.$store.getters.lookup(this.lookupName);
    },
    async maybeSaveCustomValue($event) {
      if (typeof $event == "string") {
        console.log("maybeSaveCustomValue: ", $event);
        console.log("maybeSaveCustomValue: ", this.value);
        this.errors = [];
        if (confirm("Save custom value : " + $event + "?")) {
          console.log("saving custom option...", $event);
          var newLookupOption = await this.$store.dispatch(
            "ADD_LOOKUP_OPTION",
            {
              lookupName: this.lookupName,
              lookupValue: $event
            }
          );
          if (newLookupOption) {
            return this.$emit("input", newLookupOption);
          }
          // TODO -
          //    save custom value and get object;
        } else {
          this.errors.push("Invalid selection");
        }
      } else {
        this.$emit("input", $event || null);
      }
    },
    filterItems(item, queryText, itemText) {
      return (
        item.valueid == queryText ||
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    }
  },
  computed: {
    ...mapGetters({ lookup: "lookup" }),
    theLabel() {
      if (this.label) {
        return this.label;
      }
      if (this.$attrs.placeholder) {
        return "";
      }
      if (this.lookupName) {
        return this.lookupName;
      }

      return this.label ? this.label : this.lookupName;
    }
  },
  props: {
    value: [Number, String],
    lookupName: {
      type: String,
      required: true
    },
    label: String,
    allowCustomValues: Boolean
  }
};
</script>
